module.exports = __webpack_public_path__ + "static/img/1.20bff89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/sp/1.png
// module id = zYz1
// module chunks = 0